export const fileInputAvailableExtensions = ['APNG','AVIF','GIF','SVG','WebP','doc','docx','txt','jpg', 'png', 'jpeg', 'pdf','kml'];